import { Component } from "react";
import { type ConnectedProps, connect } from "react-redux";
import UpdatePasswordForm from "./form";
import {
  StyledCheckoutComponent,
  StyledHeaderText,
  StyledStepContent,
  StyledStepHeader,
} from "@/components/checkout/uielements";
import StringAccessor from "@/components/cmsConfig/stringAccessor";
import meActions from "@/redux/me/actions";
import { type RootState } from "@/types/app";

class PasswordInformation extends Component<ReduxProps> {
  render() {
    const { me, updateMe } = this.props;

    return (
      <StyledCheckoutComponent>
        <StyledStepHeader enabled={true}>
          <StringAccessor
            accessor="account.change_password_header"
            tag={StyledHeaderText}
          />
        </StyledStepHeader>
        <StyledStepContent enabled={true}>
          {/** @TODO ensure that `me` is not null. */}
          {/** @ts-expect-error */}
          <UpdatePasswordForm initialValues={me} updateMe={updateMe} />
        </StyledStepContent>
      </StyledCheckoutComponent>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  me: state.app.me.data,
});

const mapDispatchToProps = {
  updateMe: meActions.updateMe,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(PasswordInformation);
